import CryptoJs from 'crypto-js'
const a = '2a4ac92b'
const b = '8217a77a'
const c = '44bf0314'
const d = 'c4e1b101'
const key = CryptoJs.enc.Utf8.parse(`${a}${b}`)
const iv = CryptoJs.enc.Utf8.parse(`${c}${d}`)
/**
 * AES加密
 * @param  {[type]} prama     [description]
 * @param  {[type]} timestamp [description]
 * @return {[type]}           [description]
 */
export function enctypeAes (prama, timestamp) {
  // 成产key
  let KeyStr = CryptoJs.SHA256(timestamp).toString().substring(0, 16)
  let key = CryptoJs.enc.Utf8.parse(KeyStr)
  // 生产 iv
  let ivStr = CryptoJs.SHA256(KeyStr + timestamp).toString().substring(0, 16)
  let iv = CryptoJs.enc.Utf8.parse(ivStr)
  // 加密
  let encryptResult = CryptoJs.AES.encrypt(JSON.stringify(prama), key, {
    iv: iv,
    mode: CryptoJs.mode.CBC,
    padding: CryptoJs.pad.Pkcs7
  })
  return encryptResult.toString()
}
/**
 * 解密
 * @param       {[type]} content [description]
 * @constructor
 * @return      {[type]}         [description]
 */
export function dectyptAES (content) {
  let bytes = CryptoJs.AES.decrypt(content.toString(), key, {
    iv: iv,
    mode: CryptoJs.mode.CBC,
    padding: CryptoJs.pad.Pkcs7
  })
  return bytes.toString(CryptoJs.enc.Utf8)
}
/**
 * 获取请求uuid
 * @return {[type]} [description]
 */
export function uuid () {
  let s = []
  let hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4'  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  let uuid = s.join('')
  return uuid
}
/**
 * 公共参数
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
let getDevice = () => {
  let u = navigator.userAgent
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (isAndroid) {
    return 'Android'
  } else {
    return 'IOS'
  }
}

export function authorization (currTimeStamp, body, au) {
  let data = {}
  data.os = getDevice()
  data.version = '3.0'
  data.timestamp = currTimeStamp
  data.access_token = encryptMd5(currTimeStamp).substring(11, 17).toUpperCase()
  data.cm = encryptMd5(body)
  data.au = au
  return data
}

/**
 * 获取时间戳
 * @return {[type]} [description]
 */
export function getTimeStamp () {
  return new Date().getTime().toString()
}

/**
 * md5加密
 * @param  {[type]} prama [description]
 * @return {[type]}       [description]
 */
export function encryptMd5 (prama) {
  return CryptoJs.MD5(prama).toString()
}

/**
 * Base64转码
 * @param  {[type]} prama [description]
 * @return {[type]}       [description]
 */
export function encryptBase64 (prama) {
  let str = CryptoJs.enc.Utf8.parse(prama)
  return CryptoJs.enc.Base64.stringify(str)
}

/**
 * Base64解码
 * @param  {[type]} prama [description]
 * @return {[type]}       [description]
 */
export function decryptBase64 (prama) {
  let str = CryptoJs.enc.Base64.parse(prama)
  return str.toString(CryptoJs.enc.Utf8)
}



// WEBPACK FOOTER //
// ./src/common/js/util.js